export enum ExtraLockType {
  EXTRA_LOCK_TYPE_DAY = "EXTRA_LOCK_TYPE_DAY",
  EXTRA_LOCK_TYPE_STAY = "EXTRA_LOCK_TYPE_STAY",
}

export enum ExtraType {
  EXTRA_TYPE_ROOM = "EXTRA_TYPE_ROOM",
  EXTRA_TYPE_ROOM_PER_DAY = "EXTRA_TYPE_ROOM_PER_DAY",
  EXTRA_TYPE_ROOM_MANDATORY = "EXTRA_TYPE_ROOM_MANDATORY",
  EXTRA_TYPE_ROOM_PER_DAY_MANDATORY = "EXTRA_TYPE_ROOM_PER_DAY_MANDATORY",
  EXTRA_TYPE_ROOM_SPECIFIC_DATE = "EXTRA_TYPE_ROOM_SPECIFIC_DATE",
  EXTRA_TYPE_PERSON = "EXTRA_TYPE_PERSON",
  EXTRA_TYPE_PERSON_PER_DAY = "EXTRA_TYPE_PERSON_PER_DAY",
  EXTRA_TYPE_PERSON_MANDATORY = "EXTRA_TYPE_PERSON_MANDATORY",
  EXTRA_TYPE_PERSON_PER_DAY_MANDATORY = "EXTRA_TYPE_PERSON_PER_DAY_MANDATORY",
  EXTRA_TYPE_PERSON_SPECIFIC_DATE = "EXTRA_TYPE_PERSON_SPECIFIC_DATE",
  EXTRA_TYPE_UNIT = "EXTRA_TYPE_UNIT",
  EXTRA_TYPE_UNIT_PER_DAY = "EXTRA_TYPE_UNIT_PER_DAY",
  EXTRA_TYPE_UNIT_SPECIFIC_DATE = "EXTRA_TYPE_UNIT_SPECIFIC_DATE",
}

export type RangeDateWindowType = {
  startDate: string | null;
  endDate: string | null;
};

export type TranslationType = {
  locale: string;
  name: string;
  description: string;
};

export enum ExtraUse {
  EXTRA_USE_OWN = "EXTRA_USE_OWN",
  EXTRA_USE_UNKNOWN = "EXTRA_USE_UNKNOWN",
}

export interface CustomExtraListItem {
  id: string;
  ticker: string;
  active: boolean;
  visible: boolean;
  codesList: string[];
  emailsList: string[];
  translationsList: TranslationType[];
  type: ExtraType;
  rate: ExtraRateType | number;
  availability: ExtraUse;
  lockType: ExtraLockType;
  blockage: ExtraUse;
  travelWindow: RangeDateWindowType;
  minStay?: number;
  maxStay?: number;
  minNotice?: number;
  maxNotice?: number;
  isShared?: boolean;
}

export enum ExtraRateType {
  EXTRA_RATE_TYPE_UNKNOWN = "EXTRA_RATE_TYPE_UNKNOWN",
  EXTRA_RATE_TYPE_PERCENTAGE = "EXTRA_RATE_TYPE_PERCENTAGE",
  EXTRA_RATE_TYPE_CONSTANT = "EXTRA_RATE_TYPE_CONSTANT",
  EXTRA_RATE_TYPE_FORMULA = "EXTRA_RATE_TYPE_FORMULA",
  EXTRA_RATE_TYPE_OWN = "EXTRA_RATE_TYPE_OWN",
  EXTRA_RATE_TYPE_SHARED = "EXTRA_RATE_TYPE_SHARED",
}

export enum ExtraRestrictionUse {
  EXTRA_RESTRICTION_USE_CONSTANT = "EXTRA_RESTRICTION_USE_CONSTANT",
  EXTRA_RESTRICTION_USE_UNKNOWN = "EXTRA_RESTRICTION_USE_UNKNOWN",
}

export enum ExtraApplyTo {
  EXTRA_APPLY_TO_ALL_STAY_DAYS_EXCEPT_CHECKOUT = "EXTRA_APPLY_TO_ALL_STAY_DAYS_EXCEPT_CHECKOUT",
  EXTRA_APPLY_TO_ALL_STAY_DAYS_EXCEPT_CHECKIN = "EXTRA_APPLY_TO_ALL_STAY_DAYS_EXCEPT_CHECKIN",
  EXTRA_APPLY_TO_ONLY_CHECKIN = "EXTRA_APPLY_TO_ONLY_CHECKIN",
}

export enum GuestType {
  SENIOR = "SENIOR",
  ADULT = "ADULT",
  TEENAGER = "TEENAGER",
  CHILD = "CHILD",
  BABY = "BABY",
}
